<div class="card p-3">
	<h5>Pagar Recibos</h5>

	<div class="row border-bottom pb-2 mb-3" *ngFor="let bi of bill_list">
		<div class="col-6">
			<strong>Recibo #{{bi.bill.id}}</strong>
			<span *ngIf="bi.bill.folio"> - {{bi.bill.folio}}</span>
		</div>
		<div class="col-3 text-end">{{bi.bill.total | currency:'$'}} {{bi.bill.currency_id}}</div>
		<div class="col-3 text-end text-muted">
			Pendiente: {{(bi.bill.total - bi.bill.amount_paid) | currency:'$'}}
		</div>
	</div>

	<div *ngIf="provider" class="mb-2 text-muted">
		Proveedor: <strong>{{provider.name | titlecase}}</strong>
	</div>

	<div class="row border-bottom pb-2 mb-3 align-items-end" *ngFor="let pm of pay_movements; let i = index">
		<div class="col-12 col-md-2 mb-1">
			<label class="form-label small">Método</label>
			<select [(ngModel)]="pm.transaction_type" class="form-select form-select-sm">
				<option [ngValue]="null">Seleccionar</option>
				<option value="CASH">Efectivo</option>
				<option value="TRANSFER">Transferencia</option>
				<option value="CHECK">Cheque</option>
				<option value="CREDIT_CARD">T. Crédito</option>
				<option value="DEBIT_CARD">T. Débito</option>
			</select>
		</div>
		<div class="col-12 col-md-3 mb-1">
			<label class="form-label small">Cuenta bancaria</label>
			<select [(ngModel)]="pm.bank_account_id" class="form-select form-select-sm">
				<option [ngValue]="null">Seleccionar</option>
				<option *ngFor="let ba of getFilteredAccountsForMovement(pm.transaction_type)" [value]="ba.id">
					{{ba.alias || ba.name}} - {{ba.bank}}
				</option>
			</select>
		</div>
		<div class="col-6 col-md-2 mb-1">
			<label class="form-label small">Monto</label>
			<input type="number" [(ngModel)]="pm.amount" class="form-control form-control-sm" step="any" min="0">
		</div>
		<div class="col-6 col-md-2 mb-1">
			<label class="form-label small">Fecha</label>
			<input type="date" [(ngModel)]="pm.paid_date" class="form-control form-control-sm">
		</div>
		<div class="col-8 col-md-2 mb-1">
			<label class="form-label small">Referencia</label>
			<input type="text" [(ngModel)]="pm.reference" class="form-control form-control-sm">
		</div>
		<div class="col-4 col-md-1 mb-1">
			<button type="button" (click)="removeMovement(i)" class="btn btn-sm btn-outline-secondary w-100"
				[disabled]="pay_movements.length <= 1" title="Eliminar">&times;</button>
		</div>
	</div>

	<div class="mb-2">
		<button type="button" (click)="addMovement()" class="btn btn-sm btn-outline-secondary">
			+ Agregar movimiento
		</button>
	</div>

	<div class="row border-top pt-3">
		<div class="col-6">
			<div>Total a pagar: <strong>{{getTotalPending() | currency:'$'}}</strong></div>
			<div>Movimientos: <strong>{{getPaymentTotal() | currency:'$'}}</strong></div>
			<div [class.text-danger]="(getTotalPending() - getPaymentTotal()) < -0.01">
				Restante: <strong>{{(getTotalPending() - getPaymentTotal()) | currency:'$'}}</strong>
			</div>
		</div>
		<div class="col-6 text-end align-self-end">
			<app-loading [is_loading]="is_loading"></app-loading>
			<button type="button" class="btn btn-primary" [disabled]="is_loading" (click)="submitPayment()">
				{{ is_loading ? 'Guardando...' : 'Guardar Pago' }}
			</button>
		</div>
	</div>
</div>
